import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { useCurrentSearchAlertStatus } from '@xing-com/crate-jobs-hooks';
import {
  IconNotificationCenter,
  IconNotificationFilled,
  IconSearch,
} from '@xing-com/icons';

export const SearchAlertBannerIcon: React.FC = () => {
  const { isLoggedIn } = useLoginState();
  const { searchAlertId } = useCurrentSearchAlertStatus();

  const Icon = !isLoggedIn
    ? IconSearch
    : searchAlertId
      ? IconNotificationFilled
      : IconNotificationCenter;

  return <Icon width={24} height={24} />;
};
